import { useState, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import { cancelTokenSelector } from '../redux/selectors/selectors';
import { setAlarm } from '../redux/actions/general';
import { ANALYTICS_API_URL } from '../constants/config';
import * as browserStorage from '../misc/BrowserStorageManager';
import { getUnifiedErrorObject } from '../util/ErrorUnifier';
import { useMutation } from '@tanstack/react-query';

function useRevokedTokenFetcher() {
   const jwtToken = browserStorage.getJwtToken();

   const dispatch = useDispatch();
   const cancelToken = useSelector(cancelTokenSelector);

   const [revokedMap, setRevokedMap] = useState(undefined);

   const httpHeader = useMemo(() => ({ 'x-access-token': jwtToken, 'Content-Type': 'application/json' }), [jwtToken]);

   const { mutate: fetchRevokedTokens, isLoading, error: mutationError, reset } = useMutation(
      (jtis) =>
         axios({
            method: 'POST',
            url: `${ANALYTICS_API_URL}/v2/playback/token/revoked/check`,
            data: { jtis },
            headers: httpHeader,
            cancelToken: cancelToken.token,
         }).then((res) => res.data),
      {
         onSuccess: (data) => {
            const revoked = Array.isArray(data?.revoked) ? data.revoked : [];
            const map = {};
            revoked.forEach((t) => {
               map[t] = true;
            });
            setRevokedMap(map);
         },
         onError: (err) => {
            if (!(err instanceof axios.Cancel)) {
               const errorObj = getUnifiedErrorObject(err);
               dispatch(setAlarm('danger', errorObj));
            }
         },
      },
   );

   return {
      fetchRevokedTokens,
      revokedMap,
      isLoading,
      error: mutationError ? getUnifiedErrorObject(mutationError) : undefined,
      reset,
   };
}

export default useRevokedTokenFetcher;
